export default __webpack_public_path__ + "static/media/completed.d13d2808.svg";